import './App.css';
import { INGREDIENTS } from './getIngredients.ts';
import TicTacToeCanvas from './tictactoecanvas.tsx';
import {AbstractChallenge} from './abstractchallenge.tsx';
import { AbstractCanvasProps } from './abstractcanvas.tsx';

interface TicTacToeData {
  data: string[]
}

class TicTacToe extends AbstractChallenge<TicTacToeData> {
  title() {
    return "Here's a Scrapbook Tic-Tac-Toe Challenge for you...";
  }
  
  reloadButtonText(): string {
    return "Generate New Tic-Tac-toe Challenge";
  }

  canvas(props: AbstractCanvasProps<TicTacToeData>) {
    return <TicTacToeCanvas {...props} />
  }

  getChallengeData(ingredients: INGREDIENTS): TicTacToeData {
    return {data:ingredients.pickRandom(9, true, false)};
  }
}
 
export default TicTacToe;
export type {TicTacToeData};